import { render } from "./BovineCreateButton.vue?vue&type=template&id=25fdf9e5&scoped=true"
import script from "./BovineCreateButton.vue?vue&type=script&lang=js"
export * from "./BovineCreateButton.vue?vue&type=script&lang=js"

import "./BovineCreateButton.vue?vue&type=style&index=0&id=25fdf9e5&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fdf9e5"]])

export default __exports__